import { Design } from '../../../Designs/Types'
import httpClient from '../../../httpClient'
import I18n from '../../../../helpers/I18n'

const INCLUDE_LOCALE = I18n.locale !== 'en'
const BASE_PATH = '/tools/calculators/design'
const BASE_PATH_WITH_LOCALE = INCLUDE_LOCALE ? `/${I18n.locale}${BASE_PATH}` : BASE_PATH

const CalculatorsDesignService = {
  fetchDesign: async function(designId: number): Promise<Design> {
    try {
      const response = await httpClient.get(`${BASE_PATH_WITH_LOCALE}/${designId}`)

      return response.data
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}

export default CalculatorsDesignService
